<script lang="ts">
import { onMount } from "svelte";
import isDescendant from "../../../tools/isDescendant";

    import CloseIcon from "../../icons/CloseIcon.svelte";
    import DropdownMenuItem from "./DropdownMenuItem.svelte";
    export let maxWidth = 'none';
    export let closeCallback: () => void|undefined;

    let dropdown: HTMLElement;

    if (closeCallback) {

        function globalClickHandler(e: MouseEvent) {
            if (dropdown !== e.target && !isDescendant(dropdown, e.target as Node)) {
                closeCallback();
            }
        }

        onMount(() => {
            document.addEventListener('click', globalClickHandler);
            return () => {
                document.removeEventListener('click', globalClickHandler);
            }
        });
    }
</script>

<ul class="DropdownMenu" style="max-width: {maxWidth};" bind:this={dropdown}>
    <slot></slot>
    {#if closeCallback}
        <DropdownMenuItem title="Close" onClick={closeCallback} icon={CloseIcon} />
    {/if}
</ul>

<style type="text/scss">
    .DropdownMenu {
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
        display: block;
        list-style: none;
        padding: 8px 0;
        margin: 0;
    }
</style>